module.exports = __webpack_public_path__ + "assets/img/11.9d54fc5d.png";